import { BookingInfoProperties } from "./BookingPassengerTicketIssuanceProperties";
import { AirSegmentsDetailsNew, FlightSchedulesNew } from "./flight-results-response-properties";
import { BaseFlightDetails, ChangeRBDParamsGalileo, PassengerFares } from "./FlightSearchResponseProperties";

export class ModifyFlightAirAiternary {
  bookingInfo: BookingInfoProperties;
  rbdParam: ChangeRBDParamsGalileo;
  stopsCount: number = 0;
  airSegments: AirSegmentsDetailsNew[] = [];
  modifyUser: number = 0;
  oldCancelDetails: string;
  newModifyDetails: string;
  seatRequests: AirBlueMDRQ_SeatRequest[] = [];
  baggageRequests : AirBlueMDAARQ_SpecialServiceRequest[] = [];
}

export class AirBlueMDAARQ_SpecialServiceRequest {

  itemCode: string;
  sectorIndex: number;
  passengerIndex: number;

  travelerRefNumberRPHList: string;

  flightRefNumberRPHList:string;
}
export class AirBlueMDRQ_SeatRequest {
  seatNumber: string;
  rowNumber: string;
  sectorIndex: number;
  passengerIndex: number;
  travelerRefNumberRPHList: string;
  flightRefNumberRPHList: string;
	}
export class FlightSearchProperties {
  returnDateFront: Date | null;
  returnDate: string = "";
  departureTime: string = "Any";
  returnTime: string = "";
  tripType: string = "";
  adult: number = 1;
  child: number = 0;
  infant: number = 0;
  days: number = 0;
  childAges: string[] = [];
  infantAges: string[] = [];
  cabinClass: string = "Economy";
  cabinClassReturnTrip: string = "Economy";
  fareType: string = "Low Fares";
  fareValue: string = "";
  nonStopFlight: boolean = false;
  nearByAirport: boolean = false;
  lowCostAirline: boolean = true;
  gdsAirline: boolean = true;
  prefferedAirline1: string = "";
  prefferedAirline2: string = "";
  prefferedAirline3: string = "";
  flightLocationInfo: FlightSearchDestinationProperties[] = [];
  agencyID: string = "";
  userID: number = 0;
  parentHierarchy: string = "";
  byPassSearch: boolean = false;
  adultModify: number = 0;
  childModify: number = 0;
  infantModify: number = 0;
  journeyType: number;
  groupId: number = 0;
  prefferedAirlineCheck: boolean = false;
  fareOnCall: boolean = false;
}

export class FlightSearchDestinationProperties {
  fromAirport: string = "";
  toAirport: string = "";
  fromCity: string = "";
  toCity: string = "";
  viaAirport: string = "";
  viaCity: string = "";
  departureDate: string = "";
  combineAirportFrom: string = "";
  combineAirportTo: string = "";
    modifyReturn: boolean=false;
  modifyDeparture: boolean = false;
  departureDateFront: Date | null;


}

export class BookingBasicProperties {
  flightProp: FlightSearchProperties;
  flightscheduleNew: FlightSchedulesNew;
  airSegment: AirSegmentsDetailsNew[] = []; 
  supplierCode: string;
  extraProfit: number;
  brandsSelected: boolean=false;
  nonRefundable: boolean;
  supplierPricingSolution: any;
  fareRules: any;
  stopcount: number=0;
  transactionIdentifierJ: string;
  checkInBaggage1: string;
  checkInBaggage2: string;
  passengerFares: PassengerFares[] = [];
  baggageAllowance: string;
  baggageAllowance1: string;
  selectedFareBrand1: string = "";
  selectedFareBrand2: string = "";
  bookingPCC: string;
  fromAirport: string = "";
  toAirport: string = "";
  airportsList: FlightSearchAirports[];
  groupTicketId = 0;
  bookingInfo: BookingInfoProperties;
    modifyFlight: string;
}
export class SpiceOldCancelDetails {
  OldBalanceDue: number;
  OldTotalCost: number;

}
export class SpiceNewModifyDetails {
  NewBalanceDue: number;
  NewTotalCost: number;
}
export class FlightSearchBaseData {
  airports: FlightSearchAirports[] = [];
  airlines: FlightSearchAirlineCodes[] = [];
}

export class FlightSearchAirlineCodes {
  airlineCombineCode: string = "";
  airlineName: string = "";

}
export class FlightSearchAirports {
  //iATA_CODE: string = "";
  //cityName: string = "";
  iatA_CODE: string = "";
  city: string = "";
  cityCountry: string = "";
  airportName: string = "";
  combineAirportFrom: string = "";
  combineAirportTo: string = "";
}

//export class AirSegmentsDetails {
//  depatureDateTime: string = "";
//  arrivalDateTime: string = "";
//  carrier: string = "";
//  flightNumber: string = "";
//  flightTime: string = "";
//  fromCity: string = "";
//  toCity: string = "";

//}
//export class NewForAirSegement {
//  airsegmentdetails: AirSegmentsDetails[] = [];
//}
export class AirSegmentsDetails {
  fromCity: string = "";
  toCity: string = "";
  origin: string = "";
  destination: string = "";
  fromTerminal: string = "";
  originTerminal: string = "";
  toTerminal: string = "";
  destinationTerminal: string = "";
  depatureDateTime: string;
  arrivalDateTime: string;
  carrier: string;
  flightNumber: string;
  flightTime: string;
  connectionTime: string;
  classOfService: string;
  cabinClass: string;
  flightLeagalName: string;
  flightLogo: string;
  equipment: any;
  sector: any;
}

//export class PriceCardDetails {
//  passengerType: string;
//  indivisualBasePrice: string;
//  indivisualTaxes: string;
//  indivisualTotalPrice: string;
//  totalBasePrice: string;
//  totalTaxes: string;
//  totalPrice: string;
//  passengerCount: number;
//  serviceFee: string;
//  discount: string;
//  seatFee: string;
//  mealFee: string;
//  baggageFee: string;
//}
export class PriceCardDetails {
  agencyBasePrice: string;
  agencyTaxes: string;
  agencyTotalPrice: string;
  agencyServiceFee: string;
  agencyDiscount: string;
  passengerType: string;
  indivisualBasePrice: string;
  indivisualTaxes: string;
  indivisualTotalPrice: string;
  totalBasePrice: string;
  totalTaxes: string;
  totalPrice: string;
  passengerCount: number;
  currencyRate: number = 0;
  jazCRate: number = 0;
  serviceFee: string;
  discount: string;
  seatFee: string;
  mealFee: string;
  baggageFee: string;
}

export class AirSegmentStopDetail {
  flightLeagalName: string = "";
  flightLogo: string = "";
  flightCarrier: string = "";
}
export class MinMaxProp {
  flightLeagalName: string = "";
  flightLogo: string = "";
  min: string = "";
  max: string = "";
}
export enum ActiveModifySearch {
  Oneway = 1,
  RoundTrip = 2,
  Multicity = 3
} export enum OtherFlightDetailsNames {
  ChangeBooking = 1,
  Baggage = 2,
  FareRules = 3,
  Print = 4,
  Email = 5,
  Brands = 6,
  FlightDetails = 7,
  CombinationBrands = 8,
  PassengerDetails = 9

}
export class ChildAgeProps {
  childAge: number = 0;
}
export class InfantAgeProps {
  infantAge: string = "";
}
export class FlightSearchHistory {
  historyId: number = 0;
  agencyId: string = "";
  userId: number = 0;
  fromAirport: string = "";
  toAirport: string = "";
  toCity: string = "";
  fromCity: string = "";
  fromAirportReturn: string = "";
  toAirportReturn: string = "";
  fromCityReturn: string = "";
  toCityReturn: string = "";
  departureDate: string = "";
  returnDate: string = "";
  tripType: string = "";
  travelClass: string = "";
  returnTravelClass: string = "";
  fareType: string = "";
  isNonStop: boolean;
  isLowCost: boolean;
  isGDSAirline: boolean;
  adults: number = 0;
  children: number = 0;
  infants: number = 0;
    duration: string;

}

export class FlightSearchPropModify {
  searchObj: FlightSearchProperties;
  bookingInfo: BookingInfoProperties;
}
export class FlightSearchRights {
  agencyGroupTicketSearch: boolean;
  userGroupTicketSearch: boolean;
}

export class FlyDubaiFrontProperties {
  departureFZId: number = 0;
  returnFZId: number = 0;
  MealsAnxi: string = "";
  BaggageAnxi: string = "";
  checkInBaggage1: string = "";
  selectedFareBrand1: string = "";
  selectedFareBrand2: string = "";
  checkInBaggage2: string = "";

    }

export class AljazeerafronuseSupplierPricingSolution {
  jazeeraAnxi: string = "";
  jazeeraSeats: string = "";
    }

export class PassengerSelectionList {
  paxId: number;
  label: string;
  labelText: string;
  value: number;
  min: number;
  max: number;
}
export class PassengerSelectionListInfant {
  paxId: number;
  labelInf: string;
  labelTextInf: string;
  valueInf: number;
  minInf: number;
  maxInf: number;
}
